import coverImg from "assets/images/v147/bg.webp"
import pictureImg from "assets/images/v147/cover.webp"
import titleImg from "assets/images/v147/title.webp"

export const v147Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
  picture: pictureImg,
}
